import React, { useState } from 'react';
import DataTable from '../DataTable';
import MobileTable from '../MobileTable';
import { saveProcessedDocument } from '../../utils/api';

// CSS анимация для вращения
const spinKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Добавляем стили в head, если их еще нет
if (typeof window !== 'undefined' && !window.document.querySelector('#spin-animation-styles')) {
  const style = window.document.createElement('style');
  style.id = 'spin-animation-styles';
  style.textContent = spinKeyframes;
  window.document.head.appendChild(style);
}

export default function WindowProducts({
  isOpen,
  onClose,
  document,
  positions = [],
  onOpenPrint
}) {  const [isProcessing, setIsProcessing] = useState(false);  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [manualOverride, setManualOverride] = useState(false);
  
  // Отслеживание изменения размера окна для автоматического переключения
  React.useEffect(() => {
    const handleResize = () => {
      // Автоматически переключаем только если пользователь не переключал вручную
      if (!manualOverride) {
        const shouldBeMobile = window.innerWidth < 768;
        setIsMobileView(shouldBeMobile);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [manualOverride]);

  // Функция ручного переключения
  const handleViewToggle = () => {
    setIsMobileView(!isMobileView);
    setManualOverride(true);
  };
  
  // Обработчик нажатия клавиши Escape
  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      window.document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Функция для открытия окна печати с текущим документом
  const handlePrintClick = () => {
    console.log('handlePrintClick вызван - обновлено');
    console.log('document:', document);
    console.log('onOpenPrint:', onOpenPrint);
    console.log('positions:', positions);

    if (document && onOpenPrint) {
      console.log('Вызываем onOpenPrint с параметрами:', [], document, positions);
      // Открываем окно печати, передав данные напрямую
      onOpenPrint([], document, positions);
    } else {
      console.log('Условие не выполнено:', {
        hasDocument: !!document,
        hasOnOpenPrint: !!onOpenPrint
      });
    }
  };

  // Функция обработки документа
  const handleProcessDocument = async () => {
    try {
      setIsProcessing(true);
        // Подготавливаем данные документа для отправки (оптимизированный формат)
      const documentToProcess = {
        // Основные поля документа (формат 1С)
        ДокументНомер: document?.ДокументНомер || document?.documentNumber || document?.filename || document?.id,
        ДокументДата: document?.ДокументДата || document?.created || new Date().toISOString(),
        ДокументВид: document?.ДокументВид || document?.documentType || 'Не указан',
        ДокументСтатус: 'Обработан',
        ДатаОбработки: new Date().toISOString(),
        
        // Позиции документа (единый формат для 1С и API)
        Позиции: positions.map(pos => ({
          Код: pos.Код || pos.article || '',
          Наименование: pos.Наименование || pos.name || '',
          Штрихкод: pos.Штрихкод || pos.barcode || '',
          КоличествоПлан: Number(pos.КоличествоПлан || pos.plan || 0),
          КоличествоФакт: Number(pos.КоличествоФакт || pos.fact || 0),
          КоличествоРезерв: Number(pos.КоличествоРезерв || pos.reserve || 0),
          Категория: pos.Категория || pos.category || '',
          Подкатегория: pos.Подкатегория || pos.subcategory || '',
          ТорговаяМарка: pos.ТорговаяМарка || pos.brand || '',
          Склад: pos.Склад || pos.warehouse || '',
          СтатусПозиции: pos.СтатусПозиции || pos.status || ''
        }))
      };

      console.log('Обрабатываем документ:', documentToProcess);

      const result = await saveProcessedDocument(documentToProcess);
      
      if (result.success) {
        alert(`Документ успішно оброблено!\nЗбережено як: ${result.fileName}`);
        console.log('Документ обработан:', result.fileName);
      } else {
        throw new Error(result.error || 'Невідома помилка при обробці');
      }

    } catch (error) {
      console.error('Ошибка обработки документа:', error);
      alert(`Помилка при обробці документа:\n${error.message}`);
    } finally {
      setIsProcessing(false);
    }  };
  
  // Подготавливаем данные для таблицы
  const tableData = positions.map((pos, index) => ({
    id: index + 1,
    article: pos.Код || pos.article || '',
    name: pos.Наименование || pos.name || '',
    barcode: pos.Штрихкод || pos.barcode || '',
    plan: Number(pos.КоличествоПлан || pos.plan || 0),
    fact: Number(pos.КоличествоФакт || pos.fact || 0),
    difference: Number(pos.КоличествоФакт || pos.fact || 0) - Number(pos.КоличествоПлан || pos.plan || 0)
  }));
  // Определяем колонки для таблицы
  const columns = [
    {
      key: 'article',
      title: 'Код',
      width: '120px',
      sortable: true
    },
    {
      key: 'name',
      title: 'Найменування',
      width: 'auto',
      sortable: true
    },
    {
      key: 'barcode',
      title: 'Штрих-код',
      width: '140px',
      sortable: true
    },
    {
      key: 'plan',
      title: 'План',
      width: '80px',
      sortable: true,
      textAlign: 'right',
      render: (value) => {
        const num = Number(value || 0);
        const str = num.toString();
        const dec = str.includes('.') ? str.split('.')[1] : '';
        const formatted = dec.length > 3 ? num.toFixed(3) : str;
        return <span style={{ fontWeight: 500 }}>{formatted}</span>;
      }
    },
    {
      key: 'fact',
      title: 'Факт',
      width: '80px',
      sortable: true,
      textAlign: 'right',
      render: (value) => {
        const num = Number(value || 0);
        const str = num.toString();
        const dec = str.includes('.') ? str.split('.')[1] : '';
        const formatted = dec.length > 3 ? num.toFixed(3) : str;
        return <span style={{
          fontWeight: 500,
          color: value > 0 ? '#2e7d32' : '#666'
        }}>{formatted}</span>;
      }
    },
    {
      key: 'difference',
      title: 'Різниця',
      width: '90px',
      sortable: true,
      textAlign: 'right',
      render: (value, row) => {
        const diff = Number(value || 0);
        const fact = Number(row.fact || 0);
        const str = diff.toString();
        const dec = str.includes('.') ? str.split('.')[1] : '';
        const formatted = dec.length > 3 ? diff.toFixed(3) : str;
          let backgroundColor = 'transparent';
        let color = '#666';
        
        if (diff === 0) {
          backgroundColor = '#c8e6c9'; // Зеленый фон - точное совпадение
          color = '#2e7d32';
        } else if (fact === 0) {
          backgroundColor = 'white'; // Белый фон - нет факта
          color = '#666';
        } else if (diff > 0) {
          backgroundColor = '#f8bbd9'; // Мадиновый фон - избыток
          color = '#ad1457';
        } else if (diff < 0) {
          backgroundColor = '#ffecb3'; // Оранжевый фон - недостача
          color = '#f57c00';
        }
          return (
          <span style={{
            fontWeight: 500,
            color: color,
            backgroundColor: backgroundColor,
            padding: '2px 4px',
            borderRadius: '3px',
            display: 'inline-block',
            width: '100%',
            textAlign: 'right',
            boxSizing: 'border-box'
          }}>
            {formatted}
          </span>
        );
      }
    }
  ];
  const totalPlan = tableData.reduce((sum, item) => sum + item.plan, 0);
  const totalFact = tableData.reduce((sum, item) => sum + item.fact, 0);
  const totalDifference = totalFact - totalPlan;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: window.innerWidth < 768 ? '8px' : '20px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: window.innerWidth < 768 ? '8px' : '12px',
          width: window.innerWidth < 768 ? '100%' : '90%',
          height: window.innerWidth < 768 ? '100%' : '85%',
          maxWidth: '1200px',
          maxHeight: '800px',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >        {/* Заголовок окна */}
        <div
          style={{
            padding: window.innerWidth < 768 ? '12px 16px' : '16px 24px',
            borderBottom: '1px solid #e0e0e0',
            background: 'linear-gradient(135deg, #f3e5f5 0%, #9c27b0 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <span style={{ fontSize: '32px', marginRight: '12px' }}>📦</span>
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: window.innerWidth < 768 ? '18px' : '20px',
                  fontWeight: '600',
                  color: '#7b1fa2'
                }}
              >
                Товари документа
              </h2>              <div style={{
                fontSize: '14px',
                color: '#8e24aa',
                fontWeight: '500',
                marginTop: '2px'
              }}>
                {document?.ДокументНомер || document?.documentNumber || 'Документ'}
                {document?.ДокументВид && ` • ${document.ДокументВид}`}
                {document?.ДокументДата && (
                  <span style={{ color: '#7b1fa2', fontWeight: '600' }}>
                    {` • від ${new Date(document.ДокументДата).toLocaleDateString('uk-UA')}`}
                  </span>
                )}
                {document?.isProcessed && (
                  <span style={{ 
                    marginLeft: '8px', 
                    padding: '2px 6px', 
                    backgroundColor: '#4caf50', 
                    color: 'white', 
                    borderRadius: '4px', 
                    fontSize: '10px',
                    fontWeight: 'bold'
                  }}>
                    ОБРОБЛЕНО
                  </span>
                )}              </div>            </div>
          </div>

          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#7b1fa2',
              padding: '4px',
              borderRadius: '4px',
              transition: 'background-color 0.2s',
              flexShrink: 0
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(123, 31, 162, 0.1)'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            title="Закрити"
          >
            ✕
          </button>
        </div>

        {/* Панелька с кнопкой переключения и статистикой */}
        <div
          style={{
            padding: window.innerWidth < 768 ? '8px 16px' : '12px 24px',
            borderBottom: '1px solid #e0e0e0',
            background: '#f8f9fa',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
            gap: '16px'
          }}
        >
          {/* Кнопка переключения между мобильной и десктопной версией */}
          <div>
            <button
              onClick={handleViewToggle}
              style={{
                padding: '8px 16px',
                background: 'white',
                color: '#7b1fa2',
                border: '1px solid rgba(123, 31, 162, 0.3)',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '500',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
              }}
              title={`Переключити на ${isMobileView ? 'десктопну' : 'мобільну'} версію${manualOverride ? ' (ручний режим)' : ' (авто)'}`}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f3e5f5'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
            >
              {isMobileView ? '🖥️ Десктопна версія' : '📱 Мобільна версія'}
              {manualOverride && <span style={{ fontSize: '10px', opacity: 0.7 }}> ✋</span>}
            </button>
          </div>

          {/* Статистика */}
          <div style={{
            display: 'flex',
            flexDirection: window.innerWidth < 768 ? 'column' : 'row',
            gap: window.innerWidth < 768 ? '4px' : '16px',
            alignItems: window.innerWidth < 768 ? 'flex-end' : 'center',
            background: 'white',
            padding: '8px 16px',
            borderRadius: '6px',
            fontSize: '13px',
            fontWeight: '500',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e0e0e0'
          }}>
            <div style={{ color: '#333', whiteSpace: 'nowrap' }}>
              Позицій: <strong>{tableData.length}</strong>
            </div>
            <div style={{ color: '#333', whiteSpace: 'nowrap' }}>
              План: <strong>{totalPlan.toFixed(totalPlan % 1 === 0 ? 0 : 2)}</strong>
            </div>
            <div style={{ color: '#2e7d32', whiteSpace: 'nowrap' }}>
              Факт: <strong>{totalFact.toFixed(totalFact % 1 === 0 ? 0 : 2)}</strong>  
            </div>
            <div style={{ 
              color: totalDifference === 0 ? '#2e7d32' : (totalDifference > 0 ? '#ad1457' : '#f57c00'),
              whiteSpace: 'nowrap'
            }}>
              Різниця: <strong>{totalDifference.toFixed(totalDifference % 1 === 0 ? 0 : 2)}</strong>
            </div>
          </div>
        </div>

        {/* Контент - таблица товаров */}
        <div
          style={{
            flex: 1,
            padding: window.innerWidth < 768 ? '8px' : '16px',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
        {tableData.length === 0 ? (
            <div style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              color: '#666',
              background: '#f9f9f9',
              borderRadius: '8px',
              border: '2px dashed #ccc',
              padding: '32px'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}>
                📦
              </div>
              <h3 style={{ margin: '0 0 8px 0' }}>                Немає позицій
              </h3>
              <p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}>
                У вибраному документі відсутні позиції товарів
              </p>
            </div>          ) : (            (manualOverride ? isMobileView : (isMobileView || window.innerWidth < 768)) ? (
              // Мобильная версия - используем MobileTable
              <div style={{ width: '100%' }}>
                <MobileTable
                  data={tableData}
                  searchable={true}
                />
              </div>
            ) : (
              // Десктопная версия - обычная таблица
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                overflow: 'hidden'
              }}>
                <DataTable
                  data={tableData}
                  columns={columns}
                  options={{
                    showCheckboxes: false,
                    showRowNumbers: true,
                    striped: true,
                    bordered: true,
                    hoverable: true,
                    sortable: true,
                    filterable: true, // Включаем встроенную фильтрацию DataTable
                    emptyMessage: 'Немає товарів для відображення'
                  }}
                  style={{
                    flex: 1,
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    overflow: 'hidden'
                  }}
                />
              </div>
            )
          )}
        </div>

        {/* Подвал с действиями */}
        <div
          style={{
            padding: window.innerWidth < 768 ? '12px 16px' : '16px 24px',
            borderTop: '1px solid #e0e0e0',
            background: '#f8f9fa',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexShrink: 0
          }}
        >          <div style={{ fontSize: '14px', color: '#666' }}>
            {(document?.ДокументВид || document?.ДокументНомер || document?.ДокументДата) && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', fontSize: '12px' }}>
                <div>{document?.ДокументВид || 'Документ'}</div>                <div>№ {document?.ДокументНомер || document?.documentNumber || document?.filename || 'Не вказано'}</div>
                <div>від <strong>{document?.ДокументДата ? new Date(document.ДокументДата).toLocaleDateString('uk-UA') : 'Не вказана'}</strong></div>
              </div>
            )}
          </div>

          <div style={{ display: 'flex', gap: '8px' }}>            <button
              onClick={handlePrintClick}
              style={{
                padding: window.innerWidth < 768 ? '12px' : '8px 16px',
                fontSize: window.innerWidth < 768 ? '18px' : '14px',
                background: 'rgba(33, 150, 243, 0.1)',
                color: '#2196f3',
                border: '1px solid rgba(33, 150, 243, 0.3)',
                borderRadius: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                minWidth: window.innerWidth < 768 ? '44px' : 'auto',
                height: window.innerWidth < 768 ? '44px' : 'auto',
                justifyContent: 'center'
              }}
              title="Друк документа / Print Document / Печать документа"
            >
              🖨️ {window.innerWidth >= 768 && 'Друк'}
            </button>            <button
              onClick={handleProcessDocument}
              disabled={isProcessing}
              style={{
                padding: window.innerWidth < 768 ? '12px' : '8px 16px',
                fontSize: window.innerWidth < 768 ? '18px' : '14px',
                background: isProcessing ? 'rgba(76, 175, 80, 0.05)' : (document?.isProcessed ? 'rgba(33, 150, 243, 0.1)' : 'rgba(76, 175, 80, 0.1)'),
                color: isProcessing ? '#999' : (document?.isProcessed ? '#2196f3' : '#4caf50'),
                border: isProcessing ? '1px solid rgba(153, 153, 153, 0.3)' : (document?.isProcessed ? '1px solid rgba(33, 150, 243, 0.3)' : '1px solid rgba(76, 175, 80, 0.3)'),
                borderRadius: '4px',
                cursor: isProcessing ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                minWidth: window.innerWidth < 768 ? '44px' : 'auto',
                height: window.innerWidth < 768 ? '44px' : 'auto',
                justifyContent: 'center',
                transition: 'all 0.2s ease'
              }}
              title={isProcessing ? 'Обробляється...' : (document?.isProcessed ? 'Повторно обробити документ' : 'Позначити документ як оброблений')}
            >
              {isProcessing ? (
                <>
                  <span style={{ 
                    display: 'inline-block',
                    animation: 'spin 1s linear infinite',
                    fontSize: '14px'
                  }}>⏳</span>
                  {window.innerWidth >= 768 && 'ОБРОБКА...'}
                </>
              ) : (
                <>
                  {document?.isProcessed ? '🔄' : '✅'} {window.innerWidth >= 768 && (document?.isProcessed ? 'Переобробити' : 'Оброблено')}
                </>
              )}
            </button>

            <button
              onClick={onClose}
              style={{
                padding: '8px 16px',
                background: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Закрити
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
